import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { NgxChartsModule, PieChartModule } from '@swimlane/ngx-charts';
import { MatSelectModule, MAT_CHECKBOX_CLICK_ACTION, MatRadioButton, MatRadioModule, MatDialogModule, MatInputModule, MatFormFieldModule, MatTableModule, MatIconModule, MatButtonModule } from '@angular/material';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { ResalepageComponent } from './resalepage.component';
import { ResalePageRoutingModule } from './resalepage-routing.module';


@NgModule({
  declarations: [ResalepageComponent],
  imports: [
    CommonModule,
    NgbModule,
    MatchHeightModule,
    NgxChartsModule,
    PieChartModule,
    ResalePageRoutingModule,
    MatSelectModule,
    SharedModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatRadioModule,
    FormsModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    // ResalepageModule
    ResalePageRoutingModule

  ],
  providers: [MatRadioModule,
    {provide: MAT_CHECKBOX_CLICK_ACTION, useValue: 'check'}
  ]
})
export class  ResalepageModule { }
